import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isAdmin } from 'shared/domain/role/isAdmin';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoSiteView } from 'views/site/single';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';

export const AuthorizableSiteView = React.memo((): React.ReactElement => {
  const role = useCurrentUserRole();

  const isCurrentUserAdmin = isAdmin(role);

  return (
    <MemoGenericRoleAuthorizer
      authorized={isCurrentUserAdmin}
      unauthorized={!isCurrentUserAdmin}
      authorizedComponent={MemoSiteView}
      unauthorizedComponent={InsufficientPermissionsPage}
    />
  );
});
